/**
 * Appends `preview=true` to a scheduling API URL when previewing an unpublished
 * scheduling configuration. Used to forward the preview flag from the public
 * scheduling page to every read endpoint it calls.
 */
export function buildPreviewUrl(url: string, isPreview: boolean): string {
  if (!isPreview || !url) return url
  return `${url}${url.includes(`?`) ? `&` : `?`}preview=true`
}
